import Sheet from "@/v2-ui/sheet"
import ViewSheet from "./ViewSheet"
import ViewSheetToolbar from "./ViewSheetToolbar"
import ViewSheetTitle from "./ViewSheetTitle"
import ViewSheetHeaderRow from "./ViewSheetHeaderRow"

export type { ViewSheetProps } from "./ViewSheet"
export type { ViewSheetToolbarProps } from "./ViewSheetToolbar"
export type { ViewSheetTitleProps } from "./ViewSheetTitle"
export type { ViewSheetHeaderRowProps } from "./ViewSheetHeaderRow"

export default Object.assign(ViewSheet, {
  Header: Sheet.Header,
  Title: ViewSheetTitle,
  Toolbar: ViewSheetToolbar,
  HeaderRow: ViewSheetHeaderRow,
})
